import { Component, OnInit } from '@angular/core';
import {
  NavController, NavParams
  , AlertController, LoadingController, ModalController
} from 'ionic-angular';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Storage } from '@ionic/storage';

//types
import {
  PaymentMethod, LoginInfo, CheckOutViewModel, CheckOutCartItem,
  AddressItem, ValidateCheckoutVM
} from '../model/types'

//services
import { ProductService } from '../service/product_service'
import { AppSharedService } from '../service/app_shared';

//page
import { ManageaddressPage } from '../manageaddress/manageaddress'
import { LoginPage } from '../login/login';
import { DeliveryinfoPage } from '../deliveryinfo/deliveryinfo'

@Component({
  selector: 'page-checkout',
  templateUrl: 'checkout.html',
})
export class CheckoutPage implements OnInit {

  //class variable
  paymentMethod: PaymentMethod[];
  selectedPaymentOption: number;
  selectedAddressOption: number;
  useWalletMoney: boolean;
  walletAmount: number;
  PromotionalDiscount: number;
  //constructor
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public prodService: ProductService,
    public appSharedService: AppSharedService,
    public alertCtrl: AlertController,
    private storage: Storage,
    private http: Http,
    private https: HttpClient,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
  ) {

    //initialize class level default vaue
    let paymentM1: PaymentMethod = {
      methodId: 1,
      methodName: "Cash On Delivery"
    }
    this.paymentMethod = [];
    this.paymentMethod.push(paymentM1);
    this.selectedPaymentOption = 1;
    this.selectedAddressOption = 0;
    this.useWalletMoney = true;
    this.walletAmount = 0;
    this.PromotionalDiscount = 0;
    this.initializeOnLoad();

  }

  //initalization
  ngOnInit() {

  }
  ionViewDidLoad() {
    this.prodService.utility_GetProductListFromCart();
    this.prodService.createDeliveryItemChart();
  }

  initializeOnLoad() {
    this.getCustomerShippingAddress();
  }

  walletOptChange() {
    if (this.useWalletMoney == true) {

      if (this.walletAmount > this.prodService.CartTotalAmount) {
        this.PromotionalDiscount = this.prodService.CartTotalAmount;
      }
      else {
        this.PromotionalDiscount = this.walletAmount;
      }
    }
    else {
      this.PromotionalDiscount = 0;
    }
  }
  // get customer last shipping address
  getCustomerShippingAddress() {

    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {

      if (userinfo != undefined && userinfo != null && userinfo.Token != undefined) {

        //create loader
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });

        // show loader
        loading.present();

        // creatin headers
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('token', userinfo.Token);
        const options = new RequestOptions({ headers: headers });

        //creating url
        var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlLastShippingAddress);

        //do the service call
        this.http.get(url, options)
          .subscribe((res: Response) => {
            if (res.status == 200) {

              this.prodService.deliveryInformation = JSON.parse(res.text()) as ValidateCheckoutVM;

              let defaultVal = this.prodService.deliveryInformation.addressList.find(item => item.IsDefault == true);

              if (defaultVal != undefined && defaultVal != null) {
                this.selectedAddressOption = defaultVal.AddressId;
              }
              this.prodService.createDeliveryItemChart();
              this.walletAmount = this.prodService.deliveryInformation.walletAmount;
              this.walletOptChange();
              loading.dismiss();
            }
            else if (res.status == 204) {

              loading.dismiss();
              this.storage.clear();
              this.navCtrl.popToRoot();
              this.navCtrl.setRoot(LoginPage);

            }
            else {
              loading.dismiss();
            }
          });
      }
    });
  }
  AddAddress() {
    let profileModal = this.modalCtrl.create(ManageaddressPage);

    profileModal.onDidDismiss(data => {
      if (data != undefined && data != null && data.AddressId != undefined && data.AddressId != null) {
        this.addShippingAddress(data);
      }
      else {
        this.getCustomerShippingAddress();
      }
    });
    profileModal.present();

  }

  addShippingAddress(addressdata: AddressItem) {

    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {

      //initialize url
      var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlLastShippingAddress);
      url = url + "/add";

      // show loader
      loading.present();
      addressdata.LocationId = userinfo.LocationId;

      //create header
      let myheaders = new HttpHeaders();
      myheaders = myheaders.append('Content-Type', 'application/json');
      myheaders = myheaders.append('token', userinfo.Token);

      // do the service call
      this.https.post(url, addressdata, { headers: myheaders, observe: 'response' })
        .subscribe((res: HttpResponse<any>) => {
          if (res.status == 200) {

            let message = this.appSharedService.getHttpResponseMessage(res, 'Your delivery address added successfully.');
            //dismiss loader
            loading.dismiss();

            //show message
            this.alertCtrl.create({
              title: 'Successfull',
              subTitle: message,
              buttons: ['OK']
            }).present();

            //fetch latest
            this.getCustomerShippingAddress();

          } else {

            //dismiss loader
            loading.dismiss();

            let message = this.appSharedService.getHttpResponseMessage(res, 'There is problem with adding address. please try after sometime!');

            //display error message
            this.alertCtrl.create({
              title: 'Error',
              subTitle: message,
              buttons: ['OK']
            }).present();
          }
        });
    });
  }
  // place order
  placeOrder() {

    //validation
    if (this.prodService.deliveryInformation.addressList.length == 0 || this.selectedAddressOption == 0) {
      this.alertCtrl.create({
        title: 'Error in checkout',
        subTitle: 'Billing address is required.',
        buttons: ['OK']
      }).present();
    }
    else {
      this.placeCurrentOrder();
    }
  }

  //place order 2
  placeCurrentOrder() {
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {
      //initialize model
      var items: CheckOutCartItem[] = [];
      this.prodService.MyCarItemList.forEach(obj => {
        items.push(
          {
            ProductMappingId: obj.ProductMappingId,
            OrderQuantity: obj.ProductQuantity,
            VendorId: obj.VendorId,
            ProductId: obj.ProductId,
            ProductUnitId: obj.ProductUnitId
          });
      });

      var checkoutModel: CheckOutViewModel = {
        DeliveryAddressId: this.selectedAddressOption,
        UsePromotionCoupon: this.useWalletMoney,
        CartListItem: items
      };

      //initialize url
      var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlCheckOut);

      // show loader
      loading.present();
      //create header
      let myheaders = new HttpHeaders();
      myheaders = myheaders.append('Content-Type', 'application/json');
      myheaders = myheaders.append('token', userinfo.Token);

      // do the service call
      this.https.post(url, checkoutModel, { headers: myheaders, observe: 'response' }).subscribe((res: HttpResponse<any>) => {
        if (res.status == 200) {
          let message = this.appSharedService.getHttpResponseMessage(res, 'Your order completed successfully. Please contact our support team for more information.');
          //dismiss loader
          loading.dismiss();

          //show message
          this.alertCtrl.create({
            title: 'Success',
            subTitle: message,
            buttons: ['OK']
          }).present();

          //reset details
          this.storage.remove("bz_cart_02");
          this.walletAmount = this.walletAmount - this.PromotionalDiscount;
          this.PromotionalDiscount = 0;
          this.walletOptChange();
          this.prodService.utility_GetProductListFromCart();
        }
        else if (res.status == 204) {
          loading.dismiss();
          this.storage.clear();
          this.navCtrl.popToRoot();
          this.navCtrl.setRoot(LoginPage)
        }
        else {

          let message = this.appSharedService.getHttpResponseMessage(res, 'There is problem with order placing. please try after sometime!');
          //dismiss loader
          loading.dismiss();

          //display error message
          this.alertCtrl.create({
            title: 'Error',
            subTitle: message,
            buttons: ['OK']
          }).present();
        }
      });
    });
  }

  showDeliveryPrice() {
    let data = {
      deliveryDet: this.prodService.deliveryInformation.deliveryInfoDetails
    };
    let profileModal = this.modalCtrl.create(DeliveryinfoPage, data);
    profileModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/checkout/checkout.ts